import Vue from 'vue'

Vue.prototype.$getRandomUsername = () => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ' '
  const length = 10
  const charactersLength = characters.length
  for (let i = 1; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

Vue.prototype.$getRandomPassword = () => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!#%$='
  let result = ''
  const length = 12
  const charactersLength = characters.length
  for (let i = 1; i <= length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

Vue.prototype.$DAformattedDate = value => {
  const parts = value.split('-')
  const year = Number(parts[0])
  const month = Number(parts[1])
  const day = Number(parts[2])
  const formattedDate = `${day < 10 ? '0' : ''}${day}-${month < 10 ? '0' : ''}${month}-${year}`
  return formattedDate
}

Vue.prototype.$FormformattedDate = value => {
  const parts = value.split('-')
  const day = Number(parts[0])
  const month = Number(parts[1])
  const year = Number(parts[2])
  const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`
  return formattedDate
}

Vue.prototype.$GetValidDate = value => {
  const regex = /^\d{2}-\d{2}-\d{4}$/
  if (regex.test(value)) {
    return true
  }
  return false
}
